import Quill, { Parchment } from '@kim/quill';
import './slot.less';

const Inline = Quill.import('blots/inline') as Parchment.BlotConstructor;

export class Slot extends Inline {
  static blotName = 'slot';
  static tagName = 'span';
  static className = 'mario-slot';

  static create(placeholder: string) {
    const node = super.create() as HTMLElement;
    node.dataset.placeholder = placeholder;
    return node;
  }

  static formats(node: HTMLElement) {
    return node.dataset.placeholder;
  }

  formats() {
    // @ts-ignore
    let formats = super.formats();
    // @ts-ignore
    formats['slot'] = Slot.formats(this.domNode);
    return formats;
  }

  format(name: string, value: unknown) {
    if (name === 'slot' && typeof value === 'string') {
      // @ts-ignore
      this.domNode.dataset.placeholder = value;
    } else {
      // @ts-ignore
      super.format(name, value);
    }
  }
}
